import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Icon } from 'ui';

const StyledSpan = styled.span`
  margin-top: 4px;
  color: ${p => p.theme.colors.alerts[p.severity || 0]} !important;
  font-size: 15px;
`;

const StyledIcon = styled(Icon)`
  color: ${p => p.theme.colors.alerts[p.severity || 0]} !important;
`;

const IconText = ({ className, iconType, translationKey, severity }) =>
  <StyledSpan className={className} severity={severity}>
    <StyledIcon type={iconType} severity={severity} />
    {' '}
    <FormattedMessage id={translationKey} />
  </StyledSpan>;

IconText.propTypes = {
  className: PropTypes.string,
  iconType: PropTypes.string,
  translationKey: PropTypes.string,
  severity: PropTypes.number,
};

export default IconText;
